<template>
  <DataTable
    :value="workbooks"
    v-model:expandedRows="expandedRows"
    :class="[
      workbooks && workbooks.length == 0 ? 'empty-table' : '',
      isActiveFirst ? 'active-first' : '',
    ]"
    class="scroll-table-y main-table scrollbar-custom"
    stripedRows
    @sort="sortTable"
    removableSort
    scrollable
    :loading="isLoading"
    dataKey="id"
    columnResizeMode="expand"
  >
    <Column expander style="min-width: 52px; max-width: 52px" />
    <Column field="number" header="№" style="min-width: 44px">
      <template #body="slotProps">
        {{ rowsCount + slotProps.index + 1 }}
      </template>
    </Column>
    <Column
      field="name"
      header="Наименование"
      sortable
      style="min-width: 120px"
    >
      <template #body="slotProps">
        <RouterLink
          :to="{ name: 'workbook', params: { id: slotProps.data.id } }"
        >
          {{ slotProps.data.name }}
        </RouterLink>
      </template>
    </Column>
    <Column field="tenant" header="Тенант"></Column>
    <Column field="cuser__lname" header="Пользователь">
      <template #body="slotProps">
        <span v-if="slotProps.data.cuser">
          {{ getUserName(slotProps.data.cuser) }}
        </span>
        <span v-else>-</span>
      </template>
    </Column>
    <Column
      field="ctime"
      header="Дата создания"
      sortable
      style="min-width: 153px"
    >
      <template #body="slotProps">
        {{ convertDateFromUTC(slotProps.data.ctime) }}
      </template>
    </Column>
    <Column
      field="mtime"
      header="Дата обновления"
      sortable
      style="min-width: 173px"
    >
      <template #body="slotProps">
        {{ convertDateFromUTC(slotProps.data.mtime) }}
      </template>
    </Column>

    <Column frozen alignFrozen="right">
      <template #body="slotProps">
        <div
          @click="(event) => toggle(slotProps.data.id, event)"
          aria-haspopup="true"
          aria-controls="overlay_menu"
          class="button-menu"
        >
          <span :data-segment="1" class="pi pi-ellipsis-v"></span>
        </div>
      </template>
    </Column>
    <template #expansion="slotProps">
      <div class="sub-table-container">
        <div class="sub-table-heading">Список дашбордов</div>
        <DataTable :value="slotProps.data.dashboards" class="sub-table">
          <Column field="name" header="Наименование дашборда"></Column>
          <Column field="datalens_id" header="Datalens ID" sortable> </Column>
          <Column
            field="cuser__lname"
            header="Пользователь"
            style="max-width: 150px"
          >
            <template #body="slotProps">
              <span v-if="slotProps.data.cuser">
                {{ getUserName(slotProps.data.cuser) }}
              </span>
              <span v-else>-</span>
            </template>
          </Column>
          <Column field="ctime" header="Дата создания" style="min-width: 153px">
            <template #body="slotProps">
              {{ convertDateFromUTC(slotProps.data.ctime) }}
            </template>
          </Column>
          <Column
            field="mtime"
            header="Дата обновления"
            style="min-width: 173px"
          >
            <template #body="slotPropsRole">
              {{ convertDateFromUTC(slotPropsRole.data.mtime) }}
            </template>
          </Column>
          <Column frozen alignFrozen="right">
            <template #body="slotProps">
              <div
                @click="(event) => toggleDashboards(slotProps.data.id, event)"
                aria-haspopup="true"
                aria-controls="overlay_menu"
                class="button-menu"
              >
                <span :data-segment="1" class="pi pi-ellipsis-v"></span>
              </div>
            </template>
          </Column>
        </DataTable>
      </div>
    </template>
  </DataTable>
  <Menu ref="menu" id="overlay_menu" :model="filteredItems" :popup="true" />
  <Menu
    ref="menuDashboards"
    id="overlay_menu"
    :model="filtereddashboardsItems"
    :popup="true"
  />
  <DeleteConfirmDialog
    deleted-name="воркбук и все его дашборды"
    :visible="confirmVisible.delete"
    :blocked="blockedButtonDelete"
    @close="confirmVisible.delete = false"
    @delete="deleteWorkbook"
  />
  <UsersHistoryDialog
    :entity="modifiedEntity"
    :object_id="modifiedId"
    :visible="confirmVisible.history"
    @close="confirmVisible.history = false"
  ></UsersHistoryDialog>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { useRouter } from "vue-router";

import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Menu from "primevue/menu";
import DeleteConfirmDialog from "@/shared/dialogs/DeleteConfirmDialog.vue";
import UsersHistoryDialog from "@/widgets/dialogs/UsersHistoryDialog.vue";

import { convertDateFromUTC } from "@/services/utils/DateParser";
import { getUserName } from "@/services/utils/Names";
import { useDashbordsStore } from "@/store/analytics/dasboards";
import { rootGetters } from "@/main";
import { useAuthStore } from "@/store/auth/login";

const props = defineProps<{
  workbooks: any[];
  isActiveFirst: boolean;
  isLoading: boolean;
  rowsCount: number;
}>();
const emits = defineEmits(["sortTable", "updateTable"]);
const router = useRouter();
const store = useDashbordsStore();
const authStore = useAuthStore();

let modifiedId = ref(0);
let modifiedEntity = ref("client_workbooks");
const confirmVisible = ref({
  delete: false,
  history: false,
});
const blockedButtonDelete = ref(false);
const menu = ref();
const menuDashboards = ref();
const expandedRows = ref({});

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions(["history:edit"], ["history:read"]);
});
const items = ref([
  {
    label: "История действий",
    icon: "pi pi-history",
    checkDenied: true,
    archive: "both",
    command: () => {
      confirmVisible.value.history = true;
    },
  },
  {
    label: "Редактировать",
    icon: "pi pi-pencil",
    archive: "no_archive",
    command: () => {
      router.push({ name: "workbook", params: { id: modifiedId.value } });
    },
  },
  {
    label: "Удалить",
    icon: "pi pi-trash",
    archive: "both",
    command: () => {
      confirmVisible.value.delete = true;
    },
  },
]);

const dashboardsItems = ref([
  {
    label: "История действий",
    icon: "pi pi-history",
    checkDenied: true,
    archive: "both",
    command: () => {
      confirmVisible.value.history = true;
    },
  },
]);

const filteredItems = computed(() => {
  return items.value.filter((item) => !(item.checkDenied && isDenied.value));
});

const filtereddashboardsItems = computed(() => {
  return dashboardsItems.value.filter(
    (item) => !(item.checkDenied && isDenied.value)
  );
});

const toggle = (elemId: number, event: any) => {
  modifiedId.value = elemId;
  modifiedEntity.value = "client_workbooks";
  menu.value.toggle(event);
};

const toggleDashboards = (dashboardId: number, event: any) => {
  modifiedId.value = dashboardId;
  modifiedEntity.value = "dashboards";
  menuDashboards.value.toggle(event);
};

const sortTable = (event: any) => {
  let orderField = "";
  if (event.sortField)
    orderField = event.sortOrder > 0 ? event.sortField : `-${event.sortField}`;
  emits("sortTable", orderField);
};

const deleteWorkbook = () => {
  blockedButtonDelete.value = true;
  store
    .deleteWorkbook(modifiedId.value)
    .finally(() => {
      emits("updateTable");
      blockedButtonDelete.value = false;
      confirmVisible.value.delete = false;
    })
    .catch((err) => {
      if (err.response && err.response.status == 400)
        rootGetters.toast.show("warn", "Ошибка", err.response.data.detail);
    });
};
</script>
